import React from 'react';

import './style.css';
import Button from '../../button';
import QuestionInput from './question-input';

const renderAnswers = (
  answers,
  questionId,
  handleAnswerTextChange,
  handleAnswerRightChange
) =>
  answers.map((item, index) => (
    <QuestionInput
      placeholder="Введите вариант ответа..."
      value={answers[index].answer}
      checked={answers[index].right}
      onChange={e => {
        handleAnswerTextChange(e, questionId, index);
      }}
      onRightChange={e => {
        handleAnswerRightChange(e, questionId, index);
      }}
    />
  ));

const AddQuestion = ({
  id = '',
  removeHandle = () => {},
  handleQuestionTextChange = () => {},
  question = {},
  answers = [],
  handleAddAnswer = () => {},
  handleAnswerTextChange = () => {},
  handleAnswerRightChange = () => {},
}) => {
  return (
    <div className="add-question-container">
      <div className="add-question-first-container">
        <div className="add-question-id">{id + 1}</div>
        <Button
          small
          type="secondary"
          textButton="-"
          onClick={() => {
            removeHandle(id);
          }}
        />
      </div>
      <div className="add-question-second-container">
        <div className="add-question-title-container">
          <QuestionInput
            value={question.question}
            withoutCheckbox
            placeholder="Введите текст вопроса..."
            onChange={e => {
              handleQuestionTextChange(e, id);
            }}
          />
        </div>
        <div className="add-question-answers-container">
          <div className="add-question-answers-title">Варианты ответов:</div>
          {renderAnswers(
            answers,
            id,
            handleAnswerTextChange,
            handleAnswerRightChange
          )}
          <div className="add-question-answers-add-container">
            <Button
              type="info"
              small
              textButton="Добавить вариант ответа"
              onClick={() => {
                handleAddAnswer(id);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddQuestion;
